<div class="row">
  <div class="col-md-6 mx-auto text-center">
    <div class="alert alert-light mt-3">
      <p>No data available.</p>
    </div>
  </div>
</div>
